require('./dashboard.component.scss');

class DashboardController {
  constructor($scope, $element, CurrentFilterService, PermissionService,
              LayoutService, RouterService,
  ) {
    this.$scope = $scope;
    this.$element = $element;
    this.CurrentFilterService = CurrentFilterService;
    this.permission = PermissionService;
    this.layout = LayoutService;
    this.router = RouterService;
  }

  getHeightPx(filter) {
    const marginHorz = 0.5; // percent
    const marginVert = 7; // px
    if (!filter.cardHeight) {
      if (filter.isChart() || filter.isChartArea() ||
        filter.isTree() || filter.isGraph) {
        return filter.cardWidth * this.$element.width() * ((1 - 0.01 * marginHorz) / 12) * 0.618;
      }
      return;
    }
    //const marginVert = this.$element.width() * 0.01 * marginHorz; // px
    return this.$element.width() *
      filter.cardHeight * ((1 - 0.13 * marginHorz) / 12) +
      marginVert * (filter.cardHeight - 1);
  }

  getHeight(filter) {
    let height = this.getHeightPx(filter);
    if (!height) {
      return 'auto';
    }
    return height + 'px';
  }
}

export const DashboardComponent = {
  template  : require('./dashboard.component.html'),
  bindings  : {
    filter: '<',
    filterData: '<',
  },
  controller: DashboardController,
};



// WEBPACK FOOTER //
// ./src/view/dashboard/dashboard.component.js